
export default function getDateUTC() {
    const date = new Date(); 
    const dateToUTC = date.toUTCString();
    return dateToUTC;
}